/**
 * Brand — the "Converted Closet" wordmark.
 *
 * Brand-name rule locked 2026-05-15: every user-visible
 * "Converted Closet" renders as CONVERTED CLOSET in Agenda Bold
 * + uppercase (the `.cc-brand` class handles the transform, so
 * the text is authored in normal case for accessibility/SEO).
 * Route every literal "Converted Closet" in JSX through this
 * component. Exempt: the 2024 raster logo and the
 * convertedcloset.com URL.
 */
import type { HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLSpanElement>;

export function Brand({ className, ...rest }: Props) {
  return (
    <span className={['cc-brand', className].filter(Boolean).join(' ')} {...rest}>
      Converted Closet
    </span>
  );
}
